/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */
import React from "react";
import { classNames } from "@plasmicapp/react-web";

export function Icon15Icon(props) {
  const { className, style, title, ...restProps } = props;
  return (
    <svg
      xmlns={"http://www.w3.org/2000/svg"}
      xmlnsXlink={"http://www.w3.org/1999/xlink"}
      fill={"none"}
      viewBox={"0 0 20 20"}
      height={"1em"}
      className={classNames("plasmic-default__svg", className)}
      style={style}
      {...restProps}
    >
      {title && <title>{title}</title>}

      <g clipPath={"url(#a)"}>
        <path
          fill={"#292929"}
          d={
            "M10.313 10.625a.625.625 0 1 0 0-1.25.625.625 0 0 0 0 1.25m-3.438 0a.625.625 0 1 0 0-1.25.625.625 0 0 0 0 1.25m6.875 0a.625.625 0 1 0 0-1.25.625.625 0 0 0 0 1.25"
          }
        ></path>

        <path
          stroke={"#292929"}
          strokeLinecap={"round"}
          strokeLinejoin={"round"}
          d={
            "M10.313 16.875h6.562a.624.624 0 0 0 .625-.625V9.688a7.188 7.188 0 1 0-7.187 7.187"
          }
        ></path>
      </g>

      <defs>
        <clipPath id={"a"}>
          <path fill={"#fff"} d={"M0 0h20v20H0z"}></path>
        </clipPath>
      </defs>
    </svg>
  );
}

export default Icon15Icon;
/* prettier-ignore-end */
